import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledEmptyStaticListContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: 72px 0;
`;

export const StyledIcon = styled(SWReactIcons)`
    display: flex;
    margin-right: 10px;
    svg {
        width: 170px;
        height: 170px;
    }
`;

export const StyledTextBlock = styled.div`
    display: flex;
    margin-bottom: 12px;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["300"])};
`;
